angular.module('app').factory('templatesService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var template = restAngular.all("/template/");

        return {
            getTemplates: function (data) {
                return template.
                    one("get").
                    get(data)
            }
        }
    }
]);